import { OrgAdminConstants } from '../../../_constants';

const initialState = { getPaUserPermissionListLoading: true, data: '', error: false };

export function getPaUserPermissionListReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_PA_USER_PERMISSIONS_LIST:
            return {
                getPaUserPermissionListLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_PA_USER_PERMISSIONS_LIST:
            return {
                getPaUserPermissionListLoading: false,
                data: action.getPaUserPermissionList,
                error: false
            };
        case OrgAdminConstants.PA_USER_PERMISSIONS_LIST_ERROR:
            return {
                getPaUserPermissionListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/PaUsers/getPaUserPermissionsList.reducer.js